import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ITimeMeasurement } from "src/models/General/TimeMeasurement.models";

interface TimeMeasurementState {
  timeMeasurements: ITimeMeasurement[];
  timeMeasurementToEdit: ITimeMeasurement | null;
}

const initialState: TimeMeasurementState = {
  timeMeasurements: [],
  timeMeasurementToEdit: null,
};

const TimeMeasurementSlice = createSlice({
  name: "TimeMeasurement",
  initialState,
  reducers: {
    setTimeMeasurementList: (
      state,
      action: PayloadAction<ITimeMeasurement[]>
    ) => {
      state.timeMeasurements = action.payload;
    },
    concatListTimeMeasurement: (
      state: TimeMeasurementState,
      action: PayloadAction<ITimeMeasurement[]>
    ) => {
      state.timeMeasurements = [
        ...state.timeMeasurements.concat(action.payload),
      ];
    },
    setTimeMeasurementToEdit: (
      state,
      action: PayloadAction<ITimeMeasurement | null>
    ) => {
      state.timeMeasurementToEdit = action.payload;
    },
    addTimeMeasurement: (state, action: PayloadAction<ITimeMeasurement>) => {
      state.timeMeasurements.push(action.payload);
    },
    updateTimeMeasurement: (state, action: PayloadAction<ITimeMeasurement>) => {
      let itemIndex = state.timeMeasurements.findIndex(
        item => item.timeMeasurementId === action.payload.timeMeasurementId
      );
      if (itemIndex !== -1) state.timeMeasurements[itemIndex] = action.payload;
    },
    deleteTimeMeasurement: (state, action: PayloadAction<number>) => {
      const newArray = state.timeMeasurements.filter(
        item => item.timeMeasurementId !== action.payload
      );
      state.timeMeasurements = newArray;
    },
  },
});

export const {
  setTimeMeasurementList,
  concatListTimeMeasurement,
  setTimeMeasurementToEdit,
  addTimeMeasurement,
  updateTimeMeasurement,
  deleteTimeMeasurement,
} = TimeMeasurementSlice.actions;

export default TimeMeasurementSlice.reducer;
